// libs
import React from 'react';
import isEmpty from 'lodash/isEmpty';

// components
import { OverlaySheetContext, SHEET_TRANSITION } from 'shared/components/OverlaySheet';
import Loader from 'shared/components/Loader';
import ValidityText from 'shared/layouts/Coupons/CouponsExpiry/CouponValdity/CouponValidity';

// svgs
import CloseIcon from '@nykaa/ui-components/Icons/close';

// styles
import {
  Header,
  OfferTitle,
  Subtitle,
  InfoContainer,
  CouponInfo,
  BottomContainer,
  ActionButtonOffer,
  ActionContainerPDP,
  DiscountTagWrapper,
  OverlaySheetDesktop,
  IconContainerDesktop as CloseButton,
  FixedContent,
} from './styles';

import DiscountTag from 'shared/svg/DiscountTag';

// constants
import { TEXTS } from 'shared/layouts/Coupons/constants';

// types
import { OfferDetails } from 'shared/layouts/Coupons/types';

// defs
interface ViewDetailsNudgeOfferProps {
  onHide: VoidFunction;
  offerDetails: OfferDetails;
  sheetTransition?: SHEET_TRANSITION;
}

function ViewDetailsNudgeOffer({
  onHide,
  offerDetails,
  sheetTransition = SHEET_TRANSITION.RIGHT,
}: ViewDetailsNudgeOfferProps) {
  if (isEmpty(offerDetails)) {
    return <Loader fixed={true} />;
  }
  const { title = '', description = '', expiryEpoch = 0 } = offerDetails || {};

  return (
    <OverlaySheetDesktop onHide={onHide} transitionFrom={sheetTransition} navKey={'offer-dweb'}>
      <OverlaySheetContext.Consumer>
        {({ doHide }) => (
          <FixedContent>
            <Header>
              <CloseButton onClick={doHide}>
                <CloseIcon />
              </CloseButton>
            </Header>

            <InfoContainer className="infoContainer">
              <CouponInfo>
                <DiscountTagWrapper>
                  <DiscountTag />
                </DiscountTagWrapper>
                <OfferTitle>{title}</OfferTitle>
                <Subtitle>{description}</Subtitle>
                {expiryEpoch > 0 && <ValidityText expiryEpoch={expiryEpoch} />}
              </CouponInfo>
            </InfoContainer>
            <BottomContainer showTopBorder={false} isDesktop={true}>
              <ActionContainerPDP>
                <ActionButtonOffer
                  kind={'secondary'}
                  size={'medium'}
                  shape={'default'}
                  onClick={onHide}
                >
                  {TEXTS.OKAY}
                </ActionButtonOffer>
              </ActionContainerPDP>
            </BottomContainer>
          </FixedContent>
        )}
      </OverlaySheetContext.Consumer>
    </OverlaySheetDesktop>
  );
}

export default ViewDetailsNudgeOffer;
